export enum KeyPackageAlgorithm {
  CURVE_25519 = 'CURVE_25519',
  ED_448 = 'ED_448',
}

export enum E2eePayloadType {
  RichText = 'RichText',
}

export enum SecretChatAccessRequestStatus {
  Requested = 'requested',
  Accepted = 'accepted',
  Declined = 'declined',
}

export interface IKeyPackage {
  algorithm: KeyPackageAlgorithm;
  data: ArrayBuffer;
}

export interface IUserDeviceKeyPackage {
  userId: string;
  deviceId: string;
  keyPackage?: IKeyPackage;
}

export interface IUserDeviceKeyPackages {
  keyPackages: IUserDeviceKeyPackage[];
}

export interface IUserDeviceKeyPackagesResponse {
  cursor?: string;
  keyPackages: IUserDeviceKeyPackage[];
}

export interface IE2eeAddParticipant {
  participantId: bigint;
  welcomes: IE2eeAddParticipantWelcome[];
}

export interface IE2eeAddParticipantWelcome {
  epoch: bigint;
  deviceId: string;
  userId: string;
  payload: ArrayBuffer;
}

export interface ICreateSecretChatData {
  name?: string;
  description?: string;
  avatarUrl?: string;
  participantsWelcomeMessages: IE2eeAddParticipantWelcome[];
  adminsWelcomeMessages: IE2eeAddParticipantWelcome[];
  commit: ArrayBuffer;
  epoch: bigint;
}

export interface IAddSecretGroupParticipantsData {
  groupId: string;
  participantsWelcomeMessages: IE2eeAddParticipantWelcome[];
  commit: ArrayBuffer;
  epoch: bigint;
}

export interface ICreateCommitForSecretGroupData {
  groupId: string;
  participantsWelcomeMessages: IE2eeAddParticipantWelcome[];
  commit: ArrayBuffer;
  epoch: bigint;
}

export interface IDeclineSecretChatAccessRequestsData {
  groupId: string;
  deviceId: string;
  userId: string;
}

export interface IE2eeWelcome {
  deviceId: string;
  chatId: string;
  epoch: number;
  payload: ArrayBuffer;
}

export interface IE2eeWelcomeResponse {
  nextCursor?: string;
  welcomes: IE2eeWelcome[];
}

export interface IE2eeCommit {
  epoch: number;
  payload: ArrayBuffer;
}

export interface IE2eeCommitResponse {
  nextCursor?: string;
  commits: IE2eeCommit[];
}

export type ISecretGroupParticipantChangeRequest = {
  groupId: string;
  userIds: Array<string>;
  commit: IE2eeCommit;
};

export interface IE2eeData {
  payloadType: E2eePayloadType;
}

export type IE2eeMessagePayload = IE2eeTextMessagePayload;

export interface IE2eeTextMessagePayload extends IE2eeData {
  text: string;
}

export interface ISecretChatAccessRequest {
  chatId: string;
  status: SecretChatAccessRequestStatus;
  userId: string;
  deviceId: string;
  osName: string;
  osVersion: string;
  deviceName: string;
}
